import { useState, useEffect } from 'react'
import UAParser from 'ua-parser-js'
import { UseBrowserProps } from './Type'
import { BrowserName } from './Utils'

export const useBrowser = (): UseBrowserProps => {
  const [browser, setBrowser] = useState<UseBrowserProps>({
    browser: undefined,
    major: undefined,
    os: undefined,
    success: false,
    isFullSupport: false,
    isNotSupported: false,
  })

  useEffect(() => {
    try {
      const uaParser = new UAParser.UAParser()
      uaParser.setUA(window.navigator.userAgent)
      const os = uaParser.getOS()
      const browserData = uaParser.getBrowser()
      setBrowser({
        browser: browserData?.name,
        major: browserData?.major,
        os: os?.name,
        success: true,
        isFullSupport:
          browserData?.name === BrowserName.CHROME || browserData?.name === BrowserName.FIREFOX,
        isNotSupported:
          browserData?.name === BrowserName.IE ||
          browserData?.name === BrowserName.OPERA ||
          browserData?.name === BrowserName.EDGE,
      })
    } catch (err) {
      /** */
    }
  }, [])

  return browser
}
